/** Presentation-stage guard, not a substitute for server authorization or quote enforcement. */
export function isSyntheticPreview({
  enabled = process.env.REACT_APP_QOLAK_SYNTHETIC_PREVIEW,
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
} = {}) {
  return enabled === 'true' && ['127.0.0.1', 'localhost', '[::1]'].includes(hostname);
}

/** Published only with the production backend contract release. */
export function isFinancialExecutionEnabled({production = process.env.REACT_APP_QOLAK_PRODUCTION,
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
  protocol = typeof window === 'undefined' ? '' : window.location.protocol,
  ...previewOptions} = {}) {
  return isSyntheticPreview({hostname, ...previewOptions})
    || (production === 'true' && hostname === 'app.mokaab.gold' && protocol === 'https:');
}
